import { RegisterCard } from "../../components/RegisterCard";
import { MediaUploadInput } from "../../components/MediaUploadInput";
import { CircleLoader } from "../../components/CircleLoader";
import { Utensils, PieChart, Camera, Plus } from "lucide-react";

export const CAfood = ({
  formData,
  onFormChange,
  onFormSubmit,
  loading,
}: any) => {
  const mealTypes = ["Breakfast", "Breakfast Snack", "Lunch", "Lunch Snack"];
  const qtyTypes = ["All", "Some", "None"];

  return (
    <div className="w-full max-w-5xl mx-auto p-4 animate-in fade-in">
      <RegisterCard
        title="Meal Tracking"
        details="Log meal intake and quantity consumed."
      />

      <form
        onSubmit={onFormSubmit}
        className="mt-6 bg-white rounded-[3rem] border border-slate-100 shadow-2xl overflow-hidden flex flex-col lg:flex-row"
      >
        <div className="flex-1 p-8 lg:p-12 space-y-10 order-2 lg:order-1">
          {/* Meal Selection */}
          <div className="space-y-4">
            <label className="flex items-center gap-2 text-xs font-black text-slate-400 uppercase tracking-widest ml-1">
              <Utensils size={14} /> Select Meal
            </label>
            <div className="flex flex-wrap gap-2">
              {mealTypes.map((m) => (
                <button
                  key={m}
                  type="button"
                  onClick={() => onFormChange("food", m.toLowerCase())}
                  className={`px-4 py-2.5 rounded-xl text-xs font-bold border-2 transition-all
                    ${formData["food"] === m.toLowerCase() ? "bg-blue-600 border-blue-600 text-white" : "bg-slate-50 border-transparent text-slate-500 hover:bg-slate-100"}`}
                >
                  {m}
                </button>
              ))}
            </div>
          </div>

          {/* Quantity consumed */}
          <div className="space-y-4">
            <label className="flex items-center gap-2 text-xs font-black text-slate-400 uppercase tracking-widest ml-1">
              <PieChart size={14} /> Quantity Consumed
            </label>
            <div className="grid grid-cols-3 gap-2 p-1.5 bg-slate-100 rounded-2xl max-w-sm">
              {qtyTypes.map((q) => (
                <button
                  key={q}
                  type="button"
                  onClick={() => onFormChange("quantity", q.toLowerCase())}
                  className={`py-2 rounded-xl font-bold text-xs transition-all
                    ${formData["quantity"] === q.toLowerCase() ? "bg-white text-slate-900 shadow-sm" : "text-slate-400"}`}
                >
                  {q}
                </button>
              ))}
            </div>
          </div>

          {/* Media & Details */}
          <div className="grid md:grid-cols-2 gap-8">
            <div className="space-y-4">
              <label className="text-xs font-black text-slate-400 uppercase tracking-widest">
                Media Capture
              </label>
              <div className="border-2 border-dashed border-slate-200 rounded-3xl p-4 bg-slate-50/50 hover:bg-slate-50 transition-colors">
                <MediaUploadInput
                  singleOption={false}
                  onChangeFn={(e: any, type: any) =>
                    onFormChange(
                      type === "video" ? "video" : "image",
                      e && type === "video"
                        ? e.target.files[0]
                        : e && type === "image"
                          ? e.target.files
                          : "",
                    )
                  }
                  pdfNull={true}
                />
              </div>
            </div>
            <div className="space-y-4">
              <label className="text-xs font-black text-slate-400 uppercase tracking-widest">
                Specific Meal / Description
              </label>
              <input
                type="text"
                placeholder="e.g. Rice and Chicken"
                value={formData["meal"]}
                onChange={(e) => onFormChange("meal", e.target.value)}
                className="w-full h-14 px-4 bg-slate-50 rounded-2xl border-2 border-slate-100 outline-none focus:border-blue-500"
              />
              <textarea
                placeholder="Notes for parents..."
                value={formData["description"]}
                onChange={(e) => onFormChange("description", e.target.value)}
                className="w-full p-4 bg-slate-50 rounded-2xl border-2 border-slate-100 min-h-[100px] outline-none focus:border-blue-500"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full h-16 bg-slate-900 text-white rounded-3xl font-black uppercase tracking-tighter hover:bg-black transition-all flex items-center justify-center gap-3"
          >
            {loading ? (
              <CircleLoader />
            ) : (
              <>
                <Plus /> Log Meal
              </>
            )}
          </button>
        </div>

        <div className="lg:w-80 bg-slate-50 flex flex-col items-center justify-center p-10 order-1 lg:order-2 border-l border-slate-100">
          <img
            src="/img/balanced-diet.svg"
            className="w-48 h-48 drop-shadow-2xl animate-float"
            alt="food"
          />
          <p className="mt-6 text-xs text-slate-400 font-bold uppercase tracking-widest">
            Nutritional Log
          </p>
        </div>
      </form>
    </div>
  );
};
